import { render, staticRenderFns } from "./apiQuery.vue?vue&type=template&id=2033a2ac&scoped=true&"
import script from "./apiQuery.vue?vue&type=script&lang=js&"
export * from "./apiQuery.vue?vue&type=script&lang=js&"
import style0 from "./apiQuery.vue?vue&type=style&index=0&id=2033a2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2033a2ac",
  null
  
)

export default component.exports